import axios from "axios";
import { isEmpty, isUndefined } from 'lodash';
import { detect } from 'detect-browser';
import { getLoginToken, removeLoginToken } from "./utility";
import { toast } from "react-toastify";
import { useNavigate, useLocation } from 'react-router-dom';
import Config from "./../config/config";
import ApiConfig from "./../config/apiConfig";
// import Helper from "./../utils/helper";
// import tokenService from 'helpers/services/tokenService';
// import utility from './../utils/utility';
// import Constants from "constants/FormModule";
// import configHelper from 'helpers/configHelper';
// import { removeGlobalError, handleApiErrors, handleExternalApiCatchErrors } from "./handleApiErrors";

// const { isRelativeUrl = true } = configHelper.getConfig();

/**
 * It will build the Req data for the external API according to GET and POST method
 * @params Options
 * @return JSON
 */
const _buildReqData = options => {
    const {
        content = {}, api = "", headers = {},
        urlAppend = "", dynamicUrl = false, dynamicUrlObj = {},
        responseType = '', extraHeaders = {}, ignoreRelativeUrl = false, signal
    } = options;
    const { url = '', method = '', server = '' } = ApiConfig[api];
    const { serverConfig = {} } = Config;
    const { protocol = '', host = '' } = serverConfig[server];
    // let apiDetail = dynamicUrl ? dynamicUrlObj : Config['ApiConfig'][api];
    // apiDetail = !isUndefined(apiDetail) ? apiDetail : {};
    // let { server = "xms_srv", url = '', method = '' } = apiDetail;
    // if (dynamicUrl) {
    //     server = dynamicUrlObj.server;
    //     url = dynamicUrlObj.url;
    //     method = dynamicUrlObj.method;
    // }

    ///srv/v1/forms/list/:formKey
    // const { protocol, server: apiServer } = Config['ServerConfig'][server];
    // const baseUrl = setBaseUrl(ignoreRelativeUrl, isRelativeUrl, protocol, apiServer)
    // const apiUrl = `${baseUrl}${url}${urlAppend}`;
    const baseUrl = `${protocol}://${host}/`
    const apiUrl = `${baseUrl}${url}${urlAppend}`;
    let postData = {};
    postData = setPostData(content, headers, extraHeaders);

    const isLoggerApi = api === 'error-log';
    const axiosReqData = {
        url: apiUrl,
        method,
        responseType,//added for gzip file download 
        signal,
        server, //Added for server based error handling
        isLoggerApi, //Added To not send errors to logger in case error from logger api itself
        apiUrl,
        ...postData
    };

    return axiosReqData;
    // const axiosReqDataAfterScheduleFilter = Helper.fiterScheduleReq(axiosReqData);
    // return axiosReqDataAfterScheduleFilter;
};

/** 
* It will provide a baseUrl based on the request options
*/
const setBaseUrl = (ignoreRelativeUrl, isRelativeUrl, protocol, apiServer) => {
    return ignoreRelativeUrl ? `${protocol}://${apiServer}` : isRelativeUrl ? `` : `${protocol}://${apiServer}`;
}

/**
 * It will set the POST data for the request
 * @param content
 * @return JSON
 */
const setPostData = (content, headers, extraHeaders) => {
    return {
        data: content,
        headers: {
            ...setAuthorizationHeader(),
            ...headers,
            ...extraHeaders
        }
    };
};

/**
 * It will set the Authorization Header for the Request
 * @return JSON
 */
const setAuthorizationHeader = () => {
    const token = getLoginToken();
    const authorizationToken = `Bearer ${token}`;
    const browser = detect();
    // const domain = utility.getDomain();
    // const { role = '' } = Helper.getUserInfoFromJwt() || {};
    // const sendWhitelabelId = utility.isWhitelabel() || Helper.whitelabelRoles(role);
    // const whitelabelId = sendWhitelabelId ? utility.getWhitelabelKey(Helper.whitelabelRoles(role)).toString() : ''
    return {
        "browserName": browser.name,
        "browserVersion": browser.version,
        "Content-Type": "application/json",
        Authorization: decodeURIComponent(authorizationToken),
        'crossDomain': true,
        "Access-Control-Allow-Origin": "*",
        //     channelType: utility.isMobile() ? 'MOBILE' : 'DESKTOP',
        //     whitelabel: whitelabelId,
        //     isclientlogin: !utility.isWhitelabel() && Helper.whitelabelRoles(role) ? 'clientLog' : ''
    };
};

/**
 * It will set the JWT Cookie if receive in the response header
 */
// const setJwtCookie = (headers) => {
//     const { authorization = '' } = headers;
//     if (!isEmpty(authorization) && typeof authorization == "string") {
//         utility.saveToCookie(authorization);
//     }
// };

/**
 * This Function sets tokens in LS using config service
 */

// const setConfigTokens = async (headers = {}) => {
//     const { ui_conf = '' } = headers;
//     if ((!isEmpty(ui_conf)) && utility.isJsonString(ui_conf)) {
//         const { data: configTokens = {} } = JSON.parse(ui_conf) || {};
//         if (!isEmpty(configTokens) && typeof configTokens == "object") {
//             const previousTokens = await configHelper.decryptAndGet(Constants.CONFIG_TOKENS);
//             if (isEmpty(previousTokens)) {
//                 await configHelper.encryptJSONAndSave(Constants.CONFIG_TOKENS, configTokens);
//             }
//             const _configKey = utility.isWhitelabel() ? `${utility.getWhitelabelKey()}_${Constants.CACHE_TOKENS.DASHBOARD_CONFIG}` : Constants.CACHE_TOKENS.DASHBOARD_CONFIG;
//             const _changedTokens = configHelper.isTokenChanged([
//                 _configKey
//             ], previousTokens, configTokens);
//             if (!isEmpty(_changedTokens)) {
//                 await configHelper.encryptJSONAndSave(Constants.CONFIG_TOKENS, configTokens);
//                 tokenService.dispatchEvent(_changedTokens, configTokens);
//             }
//         }
//     }
// }

/**
 * show succss msg if we got handleschedule in response headers
 */
// const showScheduleSuccessMsg = (headers = {}, response = {}) => {
//     const { handleschedule } = headers;
//     const { data = {} } = response;
//     const { status = {} } = data;
//     if(status.success && handleschedule) {
//         utility.errorToaster('Scheduled Successfully!', 5000, 'success');
//     }
// }


/**
 * This function will sanitize the response before sending it to client. Also it will handle the error scenarios
 * @return JSON
 */
const sanitizeResponse = ({ response = {}, server, apiUrl, isLoggerApi }) => {
    const { headers, data = {} } = response;
    const { errors = [], status = {} } = data;
    const { success = false } = status;
    if (!success) {
        errors.map(error => {
            const { code = 200 } = error;
            if (code == 403) {
                removeLoginToken();
                const navigate = useNavigate();
                const location = useLocation();
                const currentPath = location.pathname;
                navigate('/login?r=' + currentPath);
            } else
                toast.error(error.message || 'Something went wrong!!');
        });
        if (errors.length == 0) {
            toast.error('Something went wrong!!');
        }
    }
    // setJwtCookie(headers);
    // setConfigTokens(headers);
    // showScheduleSuccessMsg(headers, response);
    // return handleApiErrors({ response, server, apiUrl, isLoggerApi });
    return data;
};

const ExternalApiRequest = (options) => {
    const { server, isLoggerApi, apiUrl, ...reqData } = _buildReqData(options);
    // removeGlobalError(true);

    return axios(reqData)
        .then(responseData => sanitizeResponse({ response: responseData, server, apiUrl, isLoggerApi }))
        .catch((err) => {
            if (axios.isCancel(err) || err?.code === 'ERR_CANCELED') {
                return { meta: { cancelled: true } };
            }
            return {};
        }/*handleExternalApiCatchErrors(err, isLoggerApi, apiUrl)*/);
};

export default ExternalApiRequest;
